export default __webpack_public_path__ + "static/mischievousBanjo-d2e57e70b9a0897b2e64c78fa3a84eee.svg";